import { AxiosInstance } from "axios";
import { AuthResponse } from "types/user";

class AuthApi {
	http: AxiosInstance;
	constructor(axiosInstance: AxiosInstance) {
		this.http = axiosInstance;
	}

	login = (credentials: { username: string; password: string }) =>
		this.http.post<AuthResponse>("auth/login/basic/admin", credentials).then((res) => {
			localStorage.setItem("genius-order:authToken", res.data.authToken);
			return res;
		});

	refresh = () =>
		this.http.post<AuthResponse>("auth/admin-check-token").then((res) => {
			localStorage.setItem("genius-order:authToken", res.data.authToken);
			return res;
		});
}

export default AuthApi;
